export const GET_POSTS_REQUEST: 'GET_POSTS_REQUEST' = 'GET_POSTS_REQUEST';
export const GET_POSTS_FAILED: 'GET_POSTS_FAILED' = 'GET_POSTS_FAILED';
export const GET_POSTS_SUCCESS: 'GET_POSTS_SUCCESS' = 'GET_POSTS_SUCCESS';

export const ADD_POST_MODAL: 'ADD_POST_MODAL' = 'ADD_POST_MODAL';

export const CLEAR_COMMENTS: 'CLEAR_COMMENTS' = 'CLEAR_COMMENTS';

export const GET_COMMENTS_REQUEST: 'GET_COMMENTS_REQUEST' = 'GET_COMMENTS_REQUEST';
export const GET_COMMENTS_FAILED: 'GET_COMMENTS_FAILED' = 'GET_COMMENTS_FAILED';
export const GET_COMMENTS_SUCCESS: 'GET_COMMENTS_SUCCESS' = 'GET_COMMENTS_SUCCESS';

export const MORE_POSTS_REQUEST: 'MORE_POSTS_REQUEST' = 'MORE_POSTS_REQUEST';
export const MORE_POSTS_FAILED: 'MORE_POSTS_REQUEST' = 'MORE_POSTS_REQUEST';
export const MORE_POSTS_SUCCESS: 'MORE_POSTS_SUCCESS' = 'MORE_POSTS_SUCCESS';

export const POST_CARMA_UP: 'POST_CARMA_UP' = 'POST_CARMA_UP';
export const POST_CARMA_DOWN: 'POST_CARMA_DOWN' = 'POST_CARMA_DOWN';

export const COMMENT_CARMA_UP: 'COMMENT_CARMA_UP' = 'COMMENT_CARMA_UP';
export const COMMENT_CARMA_DOWN: 'COMMENT_CARMA_DOWN' = 'COMMENT_CARMA_DOWN';

export const CHANGE_CARMA: 'CHANGE_CARMA' = 'CHANGE_CARMA';

export const HIDE_ELEMENT_REQUEST: 'HIDE_ELEMENT_REQUEST' = 'HIDE_ELEMENT_REQUEST';
export const HIDE_ELEMENT_FAILED: 'HIDE_ELEMENT_FAILED' = 'HIDE_ELEMENT_FAILED';
export const HIDE_ELEMENT_SUCCESS: 'HIDE_ELEMENT_SUCCESS' = 'HIDE_ELEMENT_SUCCESS';

export const SAVE_ELEMENT_REQUEST: 'SAVE_ELEMENT_REQUEST' = 'SAVE_ELEMENT_REQUEST';
export const SAVE_ELEMENT_FAILED: 'SAVE_ELEMENT_FAILED' = 'SAVE_ELEMENT_FAILED';
export const SAVE_ELEMENT_SUCCESS: 'SAVE_ELEMENT_SUCCESS' = 'SAVE_ELEMENT_SUCCESS';

export const REPORT_ELEMENT_REQUEST: 'REPORT_ELEMENT_REQUEST' = 'REPORT_ELEMENT_REQUEST';
export const REPORT_ELEMENT_FAILED: 'REPORT_ELEMENT_FAILED' = 'REPORT_ELEMENT_FAILED';
export const REPORT_ELEMENT_SUCCESS: 'REPORT_ELEMENT_SUCCESS' = 'REPORT_ELEMENT_SUCCESS';

export const SEND_COMMENT_REQUEST: 'SEND_COMMENT_REQUEST' = 'SEND_COMMENT_REQUEST';
export const SEND_COMMENT_FAILED: 'SEND_COMMENT_FAILED' = 'SEND_COMMENT_FAILED';
export const SEND_COMMENT_SUCCESS: 'SEND_COMMENT_SUCCESS' = 'SEND_COMMENT_SUCCESS';